module.exports = __webpack_public_path__ + "img/sort-a-to-z-blue.c4d412d2.svg";